import CustomFilterText from "../unit/CustomFilterText";
import FilterAmountOriginalPrincipal from "../unit/FilterAmountOriginalPrincipal";
import FilterAmountPrincipal from "../unit/FilterAmountPrincipal";
import FilterDateLastYear from "../unit/FilterDateLastYear";
import FilterDecision from "../unit/FilterDecision";
import FilterEmployerCompany from "../unit/FilterEmployerCompany";
import FilterLoanShortStatus from "../unit/FilterLoanShortStatus";
import FilterNoteDate from "../unit/FilterNoteDate";
import FilterProduct from "../unit/FilterProduct";

const employersLoansFilters = [
  // <CustomFilterText
  //   label="Referral"
  //   source="employment_company"
  //   defaultValue=""
  //   alwaysOn
  // />,
  <FilterEmployerCompany
    label="Referral Source"
    source="employment_company"
    defaultValue=""
    alwaysOn
  />,
  <CustomFilterText label="App #" source="iId" defaultValue="" />,
  <CustomFilterText label="Loan #" source="sLoanNum" defaultValue="" />,
  <CustomFilterText label="User #" source="iUserId" defaultValue="" />,
  <FilterDateLastYear
    label="Application Submitted"
    source="application_submitted"
    before="and"
    variant="outlined"
  />,
  <FilterNoteDate label="Note Date" source="limitNoteDate" before="and" />,
  <FilterProduct label="Product" source="sProductName" before="and" />,
  <FilterAmountOriginalPrincipal
    label="Original Principal Amount"
    source="originalnoteamount"
    before="and"
  />,
  <FilterAmountPrincipal
    label="Remaining Principal Amount"
    source="activeprincipalbalance"
    before="and"
  />,
  <FilterLoanShortStatus label="Status" source="curStatus" before="and" />,
];

export default employersLoansFilters;
